import { ChangePaginationFields, ImportCandidatePaginationFields as ImportFields } from 'src/app/data-transfer/entities/pagination-fields';

const ChangeFields = ChangePaginationFields;

export interface ImportTableColumnDef {
  importSortField: string;
  changeSortField: string;
}

export const IMPORT_TABLE_COLUMNS = {
  itemId: { importSortField: ImportFields.Id, changeSortField: ChangeFields.UpdatedId },
  version: { importSortField: ImportFields.Version, changeSortField: ChangeFields.UpdatedVersion },
  exportingOrganization: { importSortField: ImportFields.OrganizationId, changeSortField: ChangeFields.OrganizationId },
  productName: { importSortField: ImportFields.ProductName, changeSortField: ChangeFields.UpdatedProductName },
  brandName: { importSortField: ImportFields.BrandName, changeSortField: ChangeFields.UpdatedBrandName },
  articleName: { importSortField: ImportFields.ArticleName, changeSortField: ChangeFields.UpdatedArticleName },
  articleNumber: { importSortField: ImportFields.ArticleNumber, changeSortField: ChangeFields.UpdatedArticleNumber },
  timestamp: { importSortField: ImportFields.ExportTimestamp, changeSortField: ChangeFields.ChangeTimestamp },
  packagingTypeName: { importSortField: ImportFields.PackagingType, changeSortField: ChangeFields.UpdatedPackagingType },
  packagingComponentCategoryName: { importSortField: ImportFields.ComponentCategory, changeSortField: ChangeFields.UpdatedComponentCategory },
  packagingComponentSubtypeName: { importSortField: ImportFields.ComponentSubtype, changeSortField: ChangeFields.UpdatedComponentSubtype },
} satisfies Record<string, ImportTableColumnDef>;

export type ImportTableColumn = keyof typeof IMPORT_TABLE_COLUMNS;

export function getImportTableSortField(column: string, isChange: boolean): string | undefined {
  const definition = (IMPORT_TABLE_COLUMNS as Record<string, ImportTableColumnDef | undefined>)[column];
  return isChange ? definition?.changeSortField : definition?.importSortField;
}

export function getImportTableCallers(isChange: boolean): Record<ImportTableColumn, string> {
  return Object.fromEntries(
    Object.entries(IMPORT_TABLE_COLUMNS).map(([column, definition]) => [column, isChange ? definition.changeSortField : definition.importSortField])
  ) as Record<ImportTableColumn, string>;
}
